// extracted by mini-css-extract-plugin
module.exports = {"container":"_3j9z6-IgiOiq-bdEAJus6"};